export default __webpack_public_path__ + "static/uipath-new-cn-logo-f2b6c73a12215ce95f94be3399865cea.svg";